// Datos centralizados de todos los productos

export const productosDestacados = {
  'placard_victoria_jacaranda': {
    name: 'Placard Victoria\nJacarandá',
    price: '$470.000',
    description: 'MEDIDAS: 240x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4438.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4439.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4435.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4436.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4437.jpeg'
    ],
    category: 'destacados'
  },
  'placard_tokio': {
    name: 'Placard Tokio',
    price: '$510.000',
    description: 'MEDIDAS: 200x200x55 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Sistema de ranura en los fondos para dar firmeza. Incluye espejo',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4498.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4499.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4497.jpeg'
    ],
    category: 'destacados'
  }
};

export const productosCocina = {
  'despensero_elsa': {
    name: 'Despensero Elsa',
    price: '$87.000',
    description: 'MEDIDAS: 60x180x30 cm. MELAMINA 15 mm. 5 estantes.',
    images: [
      '/assets/img/productos/cocina/despensero_elsa/IMG_4527.jpeg',
      '/assets/img/productos/cocina/despensero_elsa/IMG_4525.jpeg',
      '/assets/img/productos/cocina/despensero_elsa/IMG_4526.jpeg'
    ],
    category: 'cocina'
  },
  'despensero_rufus': {
    name: 'Despensero/escobero Rufus',
    price: '$115.000',
    description: 'MEDIDAS: 60x180x30 cm. MELAMINA 15 mm. Estantes y espacio para escobero.',
    images: [
      '/assets/img/productos/cocina/despensero_rufus/IMG_4516.jpeg',
      '/assets/img/productos/cocina/despensero_rufus/IMG_4517.jpeg',
      '/assets/img/productos/cocina/despensero_rufus/IMG_4515.jpeg'
    ],
    category: 'cocina'
  },
  'despensero_nacho': {
    name: 'Despensero Nacho',
    price: '$75.000',
    description: 'MEDIDAS: 40x180x30 cm. MELAMINA 15 mm. 5 estantes.',
    images: [
      '/assets/img/productos/cocina/despensero_nacho/IMG_4531.jpeg',
      '/assets/img/productos/cocina/despensero_nacho/IMG_4530.jpeg'
    ],
    category: 'cocina'
  },
  'despensero_tete': {
    name: 'Despensero Tete',
    price: '$70.000',
    description: 'MEDIDAS: 40x150x30 cm. MELAMINA 15 mm. 4 estantes.',
    images: [
      '/assets/img/productos/cocina/despensero_tete/IMG_4533.jpeg',
      '/assets/img/productos/cocina/despensero_tete/IMG_4532.jpeg'
    ],
    category: 'cocina'
  },
  'despensero_mini_elsa': {
    name: 'Despensero Mini Elsa',
    price: '$72.000',
    description: 'MEDIDAS: 150x60x30 cm. MELAMINA 15 mm. 4 estantes.',
    images: [
      '/assets/img/productos/cocina/despensero_mini_elsa/IMG_4536.jpeg',
      '/assets/img/productos/cocina/despensero_mini_elsa/IMG_4534.jpeg',
      '/assets/img/productos/cocina/despensero_mini_elsa/IMG_4535.jpeg'
    ],
    category: 'cocina'
  },
  'portamicrondas_loreta': {
    name: 'Porta Microondas Loreta',
    price: '$95.000',
    description: 'MEDIDAS: 63x113x45 cm. MELAMINA 15 mm. 2 puertas, 2 estantes, 1 cajón.',
    images: [
      '/assets/img/productos/cocina/portamicrondas_loreta/IMG_4538.jpeg',
      '/assets/img/productos/cocina/portamicrondas_loreta/IMG_4537.jpeg',
      '/assets/img/productos/cocina/portamicrondas_loreta/IMG_4539.jpeg'
    ],
    category: 'cocina'
  },

};

export const productosDormitorio = {
  'mesa_de_luz_facu': {
    name: 'Mesa de Luz Facu',
    price: '$80.000',
    description: 'MEDIDAS: 40 x 70 x 36 cm. Melamina 15 mm. Correderas metálicas. Incluye barra desayunadora. Colores: Avellana - Terra - Habano - Blanco.',
    images: [
      '/assets/img/productos/dormitorio/mesa_de_luz_facu/IMG_3356.jpeg',
      '/assets/img/productos/dormitorio/mesa_de_luz_facu/IMG_3357.jpeg',
      '/assets/img/productos/dormitorio/mesa_de_luz_facu/IMG_3358.jpeg'
    ],
    category: 'dormitorio'
  },
  'ropero_cali': {
    name: 'Ropero Cali',
    price: '$130.000',
    description: 'MEDIDAS: 87x145x38 cm. MELAMINA 15 mm. Multifunción. 5 estantes.',
    images: [
      '/assets/img/productos/dormitorio/ropero_cali/IMG_4503.jpeg',
      '/assets/img/productos/dormitorio/ropero_cali/IMG_4504.jpeg',
      '/assets/img/productos/dormitorio/ropero_cali/IMG_4502.jpeg'
    ],
    category: 'dormitorio'
  },
  'ropero_pifo': {
    name: 'Ropero Pifo',
    price: '$112.000',
    description: 'MEDIDAS: 180x60x40 cm. MELAMINA 15 mm. 5 estantes. Reversible.',
    images: [
      '/assets/img/productos/dormitorio/ropero_pifo/IMG_4501.jpeg',
      '/assets/img/productos/dormitorio/ropero_pifo/IMG_4500.jpeg'
    ],
    category: 'dormitorio'
  },
  'biblioteca_martina': {
    name: 'Biblioteca Martina',
    price: '$80.000',
    description: 'MEDIDAS: 60x180x30 cm. MELAMINA 15 mm. 5 estantes.',
    images: [
      '/assets/img/productos/dormitorio/biblioteca_martina/IMG_4505.jpeg',
      '/assets/img/productos/dormitorio/biblioteca_martina/IMG_4507.jpeg',
      '/assets/img/productos/dormitorio/biblioteca_martina/IMG_4506.jpeg'
    ],
    category: 'dormitorio'
  }, /*
  'escritorio_gamer': {
    name: 'Escritorio Gamer',
    price: '$125.000',
    description: 'MEDIDAS: 118x93x50 cm. MELAMINA 15 mm. Estante para CPU. 4 estantes.',
    images: [
      '/assets/img/productos/dormitorio/escritorio_gamer/IMG_4524.jpeg',
      '/assets/img/productos/dormitorio/escritorio_gamer/IMG_4523.jpeg',
      '/assets/img/productos/dormitorio/escritorio_gamer/IMG_4522.jpeg'
    ],
    category: 'dormitorio'
  }, */
  'biblioteca_morita': {
    name: 'Biblioteca Morita',
    price: '$90.000',
    description: 'MEDIDAS: 90x180x25 cm. MELAMINA 15 mm. Diseño minimalista. Se puede armar horizontal o vertical.',
    images: [
      '/assets/img/productos/dormitorio/biblioteca_morita/IMG_4511.jpeg',
      '/assets/img/productos/dormitorio/biblioteca_morita/IMG_4510.jpeg',
      '/assets/img/productos/dormitorio/biblioteca_morita/IMG_4512.jpeg'
    ],
    category: 'dormitorio'
  }, /*
  'sommier_piero': {
    name: 'Sommier Piero 1 plaza',
    price: '$190.000',
    description: 'MODELO: PIERO BODY PRO\n\nCARACTERÍSTICAS:\n-SOPORTE: RECOMENDADO PARA PERSONAS DE HASTA 70 KG.\n-ESPUMA DE ALTA DENSIDAD. LE DA GRAN FIRMEZA PERMITIENDO QUE LA ESPALDA Y COLUMNA VERTEBRAL DESCANSEN ADECUADAMENTE.\n-TOTALMENTE MATELASSEADO CON TELA DE SABANA.\n-DENSIDAD: 21 KG/M3.\n-DESARROLLADO CON PROCESO AIR FLOW.\nPERMEABILIDAD DE AIRE CONTROLADA. EVITA LA CALUROSA SENSACION DE LOS COLCHONES CONVENCIONALES.\n-SOMMIER RIGIDO DE MADERA SELECCIONADA Y CONTROL DE HUMEDAD.\n-MEDIDAS DEL COLCHON: 80 CMTS. DE ANCHO X 18 CMTS. DE ALTO X 190 CMTS. DE LARGO.\n-MEDIDAS DEL SOMMIER: 80 CMTS. DE ANCHO X 20 CMTS. DE ALTO (SIN PATAS) X 190 CMTS. DE LARGO',
    images: [
      '/assets/img/productos/dormitorio/sommier_piero/IMG_4847.jpeg',
      '/assets/img/productos/dormitorio/sommier_piero/IMG_4848.jpeg'
    ],
    category: 'dormitorio'
  }, */
  'colchon_piero': {
    name: 'Colchon Piero 1 plaza',
    price: '$120.000',
    description: 'Colchón piero Body Pro\n\nCaracterísticas:\n-RECOMENDADO PARA PERSONAS DE HASTA 70 kg\n-ESPUMA DE ALTA DENSIDAD. LE DA GRAN FIRMEZA PERMITIENDO QUE LA ESPALDA Y COLUMNA VERTEBRAL DESCANSEN ADECUADAMENTE.\n-TOTALMENTE MATELASSEADO CON TELA DE SABANA.\n-DENSIDAD: 21 KG/M3.\n-DESARROLLADO CON PROCESO AIR FLOW.\nPERMEABILIDAD DE AIRE CONTROLADA. EVITA LA CALUROSA SENSACION DE LOS COLCHONES CONVENCIONALES.\n-MEDIDAS DEL COLCHON: 80 CMTS. DE ANCHO X 18 CMTS. DE ALTO X 190 CMTS. DE LARGO.',
    images: [
      '/assets/img/productos/dormitorio/colchon_piero/IMG_4849.jpeg',
      '/assets/img/productos/dormitorio/colchon_piero/IMG_4848.jpeg'
    ],
    category: 'dormitorio'
  },
  'colchon_2plazas': {
    name: 'Colchon Piero Body pro 2 plazas',
    price: '$150.000',
    description: 'Colchón piero body pro 2 plazas\n\nESPUMA DE ALTA DENSIDAD. LE DA GRAN FIRMEZA PERMITIENDO QUE LA ESPALDA Y COLUMNA VERTEBRAL DESCANSEN ADECUADAMENTE.\n-TOTALMENTE MATELASSEADO CON TELA DE SABANA.\n-DENSIDAD: 21 KG/M3.\n-DESARROLLADO CON PROCESO AIR FLOW.\nPERMEABILIDAD DE AIRE CONTROLADA. EVITA LA CALUROSA SENSACION DE LOS COLCHONES CONVENCIONALES.\nCONTROL DE HUMEDAD.\nMEDIDAS:190x140x18 cm',
    images: [
      '/assets/img/productos/dormitorio/colchon_2plazas/IMG_4851.jpeg',
      '/assets/img/productos/dormitorio/colchon_2plazas/IMG_4848.jpeg',
      '/assets/img/productos/dormitorio/colchon_2plazas/IMG_4852.jpeg'
    ],
    category: 'dormitorio'
  }
};

export const productosLiving = {

  'biblioteca_martina_living': {
    name: 'Biblioteca Martina',
    price: '$85.000',
    description: 'MEDIDAS: 60x180x30 cm. MELAMINA 15 mm. 5 estantes.',
    images: [
      '/assets/img/productos/living/biblioteca_martina/IMG_4505.jpeg',
      '/assets/img/productos/living/biblioteca_martina/IMG_4507.jpeg',
      '/assets/img/productos/living/biblioteca_martina/IMG_4506.jpeg'
    ],
    category: 'living'
  },

  'organizador_ale': {
    name: 'Organizador Ale',
    price: '$105.000',
    description: 'MEDIDAS: 118x60x30 cm. MELAMINA 15 mm. Ideal para hogar/oficina. Multifunción.',
    images: [
      '/assets/img/productos/living/organizador_ale/IMG_4521.jpeg',
      '/assets/img/productos/living/organizador_ale/IMG_4520.jpeg',
      '/assets/img/productos/living/organizador_ale/IMG_4518.jpeg',
      '/assets/img/productos/living/organizador_ale/IMG_4519.jpeg'
    ],
    category: 'living'
  },


  'biblioteca_morita_living': {
    name: 'Biblioteca Morita',
    price: '$90.000',
    description: 'MEDIDAS: 90x180x25 cm. MELAMINA 15 mm. Diseño minimalista. Se puede armar horizontal o vertical.',
    images: [
      '/assets/img/productos/living/biblioteca_morita/IMG_4511.jpeg',
      '/assets/img/productos/living/biblioteca_morita/IMG_4510.jpeg',
      '/assets/img/productos/living/biblioteca_morita/IMG_4512.jpeg'
    ],
    category: 'living'
  },
  'multiuso_tom': {
    name: 'Multiuso Tom',
    price: '$95.000',
    description: 'MEDIDAS: 60x180x30 cm. MELAMINA 15 mm. 3 estantes, 2 puertas.',
    images: [
      '/assets/img/productos/living/multiuso_tom/IMG_4514.jpeg',
      '/assets/img/productos/living/multiuso_tom/IMG_4513.jpeg'
    ],
    category: 'living'
  }
};

export const productosPlacards = {
  // Placards sin baulera
  'placard_mini_tokio': {
    name: 'Placard Mini Tokio',
    price: '$390.000',
    description: 'MEDIDAS: 136x200x55 cm. Melamina 15 mm. Guías de aluminio superior e inferior. Incluye puertas y bárrales. Cajones correderas telescópicas.',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_mini_tokio/IMG_3347.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_mini_tokio/IMG_3346.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_mini_tokio/IMG_3345.jpeg'
    ],
    category: 'placards'
  },
  'placard_gisela': {
    name: 'Placard Gisela',
    price: '$590.000',
    description: 'MEDIDAS: 200 x 200 x 59 cm. Melamina 15 mm. Guías de aluminio superior e inferior. Incluye puertas y bárrales. Cajones correderas telescópicas.',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_gisela/IMG_3353.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_gisela/IMG_3354.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_gisela/IMG_3355.jpeg'
    ],
    category: 'placards'
  },
  'placard_victoria_blanco': {
    name: 'Placard Victoria Blanco',
    price: '$430.000',
    description: 'MEDIDAS: 240x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_victoria_blanco/IMG_4434.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_blanco/IMG_4435.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_blanco/IMG_4433.jpeg'
    ],
    category: 'placards'
  },
  'placard_bony_moderno': {
    name: 'Placard Bony Moderno',
    price: '$350.000',
    description: 'MEDIDAS: 180x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_bony_moderno/IMG_4425.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_moderno/IMG_4426.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_moderno/IMG_4423.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_moderno/IMG_4424.jpeg'
    ],
    category: 'placards'
  },
  'placard_milo': {
    name: 'Placard Milo',
    price: '$410.000',
    description: 'MEDIDAS: 200x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_milo/IMG_4455.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_milo/IMG_4454.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_milo/IMG_4456.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_milo/IMG_4453.jpeg'
    ],
    category: 'placards'
  },
  'placard_ramon': {
    name: 'Placard Ramón',
    price: '$265.000',
    description: 'MEDIDAS: 150x180x50 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_ramon/IMG_4430.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_ramon/IMG_4428.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_ramon/IMG_4431.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_ramon/IMG_4429.jpeg'
    ],
    category: 'placards'
  },
  'placard_vico': {
    name: 'Placard Vico',
    price: '$480.000',
    description: 'MEDIDAS: 240 de ancho x 180 de alto. MELAMINA 15 mm. Guías superior e inferior de aluminio. Cajones correderas metálicas. Incluye puertas y bárrales. Perfileria de aluminio en puertas. Fondos con sistema de ranura que le dan más firmeza al placard',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_vico/IMG_6396.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_vico/IMG_6397.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_vico/IMG_6398.jpeg'
    ],
    category: 'placards'
  },
  'placard_victoria_jacaranda': {
    name: 'Placard Victoria\nJacarandá',
    price: '$470.000',
    description: 'MEDIDAS: 240x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4438.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4439.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4435.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4436.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_jacaranda/IMG_4437.jpeg'
    ],
    category: 'placards'
  },
  'placard_alaska': {
    name: 'Placard Alaska',
    price: '$315.000',
    description: 'MEDIDAS: 140x180x54 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_alaska/IMG_4443.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_alaska/IMG_4442.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_alaska/IMG_4441.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_alaska/IMG_4444.jpeg'
    ],
    category: 'placards'
  },
  'placard_bony_jacaranda': {
    name: 'Placard Bony Jacarandá',
    price: '$385.000',
    description: 'MEDIDAS: 180x180x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_bony_jacaranda/IMG_4448.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_jacaranda/IMG_4447.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_jacaranda/IMG_4445.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_bony_jacaranda/IMG_4446.jpeg'
    ],
    category: 'placards'
  },
  'placard_ignacio_gold': {
    name: 'Placard Ignacio Gold',
    price: '$390.000',
    description: 'MELAMINA 15 mm. Guías superior e inferior de aluminio. Cajones correderas metálicas. Incluye puertas y bárrales. Perfileria de aluminio en puertas, y fondos con sistema de ranura que le dan más firmeza al placard. Medidas: 180x180x55',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_ignacio_gold/IMG_5153.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_ignacio_gold/IMG_5154.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_ignacio_gold/IMG_5155.jpeg'
    ],
    category: 'placards'
  },
  'placard_siza': {
    name: 'Placard Siza',
    price: '$225.000',
    description: 'MEDIDAS: 120x180x51 cm. MELAMINA 15 mm. Guías de aluminio superior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_siza/IMG_4451.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_siza/IMG_4452.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_siza/IMG_4450.jpeg'
    ],
    category: 'placards'
  },/*
  'placard_siza_gold': {
    name: 'Placard Siza Gold',
    price: '$240.000',
    description: 'MELAMINA 15 mm. Guías superior e inferior de aluminio. Cajones correderas metálicas. Incluye puertas y bárrales',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_siza_gold/IMG_5184.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_siza_gold/IMG_5182.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_siza_gold/IMG_5183.jpeg'
    ],
    category: 'placards'
  },*/
  'placard_jorgito': {
    name: 'Placard Jorgito',
    price: '$345.000',
    description: 'PREMIUM! Medidas: 160x180x55 cm. Guías de aluminio superior e inferior. Cajones correderas metálicas',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_jorgito/IMG_6471.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_jorgito/IMG_6472.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_jorgito/IMG_6473.jpeg'
    ],
    category: 'placards'
  },
  'placard_antartida': {
    name: 'Placard Antártida',
    price: '$440.000',
    description: 'MEDIDAS: 140x200x59 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Sistema de ranura en fondos para dar firmeza. Con espejo!',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_antartida/IMG_4484.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_antartida/IMG_4482.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_antartida/IMG_4483.jpeg'
    ],
    category: 'placards'
  },
  'placard_zafiro': {
    name: 'Placard Zafiro',
    price: '$685.000',
    description: 'MEDIDAS: 240x220x59 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Sistema de ranuras en fondos para dar firmeza. Baulera desmontable. 2 puertas de color y 2 blancas. Con espacio para TV de hasta 50 pulgadas!',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_zafiro/IMG_4487.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_zafiro/IMG_4488.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_zafiro/IMG_4490.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_zafiro/IMG_4491.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_zafiro/IMG_4486.jpeg'
    ],
    category: 'placards'
  },
  'placard_tokio': {
    name: 'Placard Tokio',
    price: '$510.000',
    description: 'MEDIDAS: 200x200x55 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Sistema de ranura en los fondos para dar firmeza. Incluye espejo',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4498.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4499.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_tokio/IMG_4497.jpeg'
    ],
    category: 'placards'
  },
  'placard_victoria_gold': {
    name: 'Placard Victoria Gold',
    price: '$650.000',
    description: 'MEDIDAS: 240x220x59 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones correderos metálicos. Incluye puertas y bárrales. Sistema de ranuras en fondos para dar firmeza. Baulera desmontable.',
    images: [
      '/assets/img/productos/placards/sin_baulera/placard_victoria_gold/IMG_4494.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_gold/IMG_4495.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_gold/IMG_4496.jpeg',
      '/assets/img/productos/placards/sin_baulera/placard_victoria_gold/IMG_4493.jpeg'
    ],
    category: 'placards'
  },
  // Placards con baulera
  'placard_y_baulera_ignacio_gold': {
    name: 'Placard y Baulera Ignacio Gold',
    price: '$530.000',
    description: 'MEDIDAS: 180 x 235 x 55 cm. Melamina 15 mm. Guías de aluminio superior e inferior. Incluye puertas y bárrales. Cajones correderas telescópicas.',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_ignacio_gold/IMG_3352.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_ignacio_gold/IMG_3351.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_ignacio_gold/IMG_3350.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_milo': {
    name: 'Placard y Baulera Milo',
    price: '$561.000',
    description: 'MEDIDAS: 200x233x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_milo/IMG_4462.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_milo/IMG_4461.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_milo/IMG_4459.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_milo/IMG_4460.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_bony_blanco': {
    name: 'Placard y Baulera Bony Blanco',
    price: '$483.000',
    description: 'MEDIDAS: 180x233x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_bony_blanco/IMG_4467.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_bony_blanco/IMG_4468.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_bony_blanco/IMG_4466.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_bony_jacaranda': {
    name: 'Placard y Baulera Bony Jacarandá',
    price: '$535.000',
    description: 'MEDIDAS: 180x233x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_bony_jacaranda/IMG_4464.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_bony_jacaranda/IMG_4463.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_victoria_blanco': {
    name: 'Placard y Baulera Victoria Blanco',
    price: '$588.000',
    description: 'MEDIDAS: 240x233x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_blanco/IMG_4473.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_blanco/IMG_4472.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_blanco/IMG_4474.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_blanco/IMG_4471.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_victoria_jacaranda': {
    name: 'Placard y Baulera Victoria Jacarandá',
    price: '$653.000',
    description: 'MEDIDAS: 240x233x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_jacaranda/IMG_4476.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_jacaranda/IMG_4478.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_victoria_jacaranda/IMG_4475.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_tokio': {
    name: 'Placard y Baulera Tokio',
    price: '$650.000',
    description: 'MEDIDAS: 200 de ancho x 240 de alto. MELAMINA 15 mm. Guías superior e inferior de aluminio. Cajones correderas metálicas. Incluye puertas y bárrales. Perfilería de aluminio en puertas, y fondos con sistema de ranura que le dan más firmeza al placard.',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_tokio/IMG_5178.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_tokio/IMG_5177.jpeg'
    ],
    category: 'placards'
  }, /*
  'placard_y_baulera_delfina': {
    name: 'Placard y Baulera\nDelfina',
    price: '$510.000',
    description: 'MEDIDAS: 180x220x56 cm. MELAMINA 15 mm. Guías de aluminio superior e inferior. Cajones con correderas metálicas. Incluye puertas y bárrales. Los muebles vienen en caja cerrada con sus debidas instrucciones y todo lo necesario para su armado (tornillos, tarugos, clavos, etc.)',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_delfina/IMG_4480.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_delfina/IMG_4481.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_delfina/IMG_4479.jpeg'
    ],
    category: 'placards'
  }, */
  'placard_y_baulera_vico': {
    name: 'Placard y Baulera Vico',
    price: '$650.000',
    description: 'MEDIDAS: 240 de ancho x 235 de alto. MELAMINA 15 mm. Guías superior e inferior de aluminio. Cajones correderas metálicas. Incluye puertas y bárrales. Perfilería de aluminio en puertas, y fondos con sistema de ranura que le dan más firmeza al placard.',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_vico/IMG_5342.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_vico/IMG_5343.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_siza': {
    name: 'Placard y Baulera SIZA',
    price: '$345.000',
    description: 'MEDIDAS: 120 x 233 x 51 cm. Melamina 15 mm. Guías y correderas metálicas. Incluye puertas y bárrales.',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_siza/IMG_3310.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_siza/IMG_3313.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_siza/IMG_3314.jpeg'
    ],
    category: 'placards'
  },
  'placard_y_baulera_ramon': {
    name: 'Placard y Baulera Ramon',
    price: '$395.000',
    description: 'MEDIDAS: 150 x 233 x 50 cm. Melamina 15 mm. Guías y correderas metálicas. Incluye puertas y bárrales.',
    images: [
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_ramon/IMG_3360.jpeg',
      '/assets/img/productos/placards/con_baulera/placard_y_baulera_ramon/IMG_3361.jpeg'
    ],
    category: 'placards'
  }
};

// Productos de Entretenimiento
export const productosEntretenimiento = {
  'rack_tv_paris': {
    name: 'Rack TV Paris',
    price: '$165.000',
    description: 'MEDIDAS: 136x66x36 cm. Color Negro y Cinamomo. Off White y Nogal. Off White y Cinamomo.',
    images: [
      '/assets/img/productos/entretenimiento/rack_paris/IMG_4552.jpeg',
      '/assets/img/productos/entretenimiento/rack_paris/IMG_4551.jpeg',
      '/assets/img/productos/entretenimiento/rack_paris/IMG_4549.jpeg',
      '/assets/img/productos/entretenimiento/rack_paris/IMG_4550.jpeg'
    ],
    category: 'entretenimiento'
  },
  'rack_tv_elena': {
    name: 'Rack TV Elena',
    price: '$88.000',
    description: 'MELAMINA 15 mm. 2 puertas. Patas de plástico simil metal. 2 estantes. Tiradores.',
    images: [
      '/assets/img/productos/entretenimiento/rack_elena/IMG_6393.jpeg',
      '/assets/img/productos/entretenimiento/rack_elena/IMG_6394.jpeg'
    ],
    category: 'entretenimiento'
  },
  'chifonnier_viena': {
    name: 'Chifonier Viena',
    price: '$175.000',
    description: 'MEDIDAS: 76x128x45. Características: 6 cajones amplios con correderas metálicas. Colores: blanco-terra-habano',
    images: [
      '/assets/img/productos/entretenimiento/chifonnier_viena/IMG_6441.jpeg',
      '/assets/img/productos/entretenimiento/chifonnier_viena/IMG_6440.jpeg',
      '/assets/img/productos/entretenimiento/chifonnier_viena/IMG_6439.jpeg'
    ],
    category: 'entretenimiento'
  },
  'comoda_david': {
    name: 'Cómoda David',
    price: '$175.000',
    description: 'Cajones amplios con correderas metálicas. Espacio para TV/CONSOLAS. 1 puerta con 3 estantes. Colores: blanco-castaño-habano',
    images: [
      '/assets/img/productos/entretenimiento/comoda_david/IMG_6442.jpeg',
      '/assets/img/productos/entretenimiento/comoda_david/IMG_6443.jpeg',
      '/assets/img/productos/entretenimiento/comoda_david/IMG_6444.jpeg'
    ],
    category: 'entretenimiento'
  },
  'rack_tv_flotante_black': {
    name: 'Rack TV Flotante Black',
    price: '$95.000',
    description: 'MEDIDAS: 136x30x20 cm. MELAMINA 15 mm. Color Negro.',
    images: [
      '/assets/img/productos/entretenimiento/rack_flotante/IMG_4541.jpeg',
      '/assets/img/productos/entretenimiento/rack_flotante/IMG_4540.jpeg'
    ],
    category: 'entretenimiento'
  },
  'vajillero_bahiut_praga': {
    name: 'Vajillero Bahiut Praga',
    price: '$250.000',
    description: 'MEDIDAS: 160x79x40 cm. Color Off White y Cinamomo.',
    images: [
      '/assets/img/productos/entretenimiento/vajillero_bahiut_praga/IMG_4553.jpeg',
      '/assets/img/productos/entretenimiento/vajillero_bahiut_praga/IMG_4554.jpeg',
      '/assets/img/productos/entretenimiento/vajillero_bahiut_praga/IMG_4555.jpeg'
    ],
    category: 'entretenimiento'
  },
  'mesa_ambiente_sky': {
    name: 'Mesa de Ambiente Sky',
    price: '$230.000',
    description: 'MELAMINA 15 mm. Mesa de centro para living. Disponible en color Nogal y Off White. Viene el PAR!',
    images: [
      '/assets/img/productos/entretenimiento/mesa_sky/IMG_4542.jpeg',
      '/assets/img/productos/entretenimiento/mesa_sky/IMG_4544.jpeg',
      '/assets/img/productos/entretenimiento/mesa_sky/IMG_4545.jpeg',
      '/assets/img/productos/entretenimiento/mesa_sky/IMG_4543.jpeg'
    ],
    category: 'entretenimiento'
  },
  'espejo_candy': {
    name: 'Espejo Candy',
    price: '$80.000',
    description: 'MEDIDAS: 67x109 cm. Soportes para pared con cuero sintético. Espejo de 33 mm con base de MDF.',
    images: [
      '/assets/img/productos/entretenimiento/espejo_candy/IMG_4546.jpeg',
      '/assets/img/productos/entretenimiento/espejo_candy/IMG_4548.jpeg',
      '/assets/img/productos/entretenimiento/espejo_candy/IMG_4547.jpeg'
    ],
    category: 'entretenimiento'
  },
  'panel_ilusion': {
    name: 'Panel Ilusion',
    price: '$325.000',
    description: 'MEDIDAS: 180x158x33,5 cm. Melamina 15 mm.',
    images: [
      '/assets/img/productos/entretenimiento/panel_ilusion/IMG_4930.jpeg',
      '/assets/img/productos/entretenimiento/panel_ilusion/IMG_4932.jpeg',
      '/assets/img/productos/entretenimiento/panel_ilusion/IMG_4931.jpeg'
    ],
    category: 'entretenimiento'
  },
  'rack_quantum': {
    name: 'Rack TV quantum',
    price: '$190.000',
    description: 'Color Negro y Cinamomo.',
    images: [
      '/assets/img/productos/entretenimiento/rack_quantum/IMG_4639.jpeg',
      '/assets/img/productos/entretenimiento/rack_quantum/IMG_4640.jpeg'
    ],
    category: 'entretenimiento'
  }
};

// Función para obtener todos los productos
export const getAllProducts = () => {
  return {
    ...productosDestacados,
    ...productosCocina,
    ...productosDormitorio,
    ...productosLiving,
    ...productosPlacards,
    ...productosEntretenimiento
  };
};

// Función para obtener productos por categoría
export const getProductsByCategory = (category) => {
  switch (category) {
    case 'destacados':
      return productosDestacados;
    case 'cocina':
      return productosCocina;
    case 'dormitorio':
      return productosDormitorio;
    case 'living':
      return productosLiving;
    case 'placards':
      return productosPlacards;
    case 'entretenimiento':
      return productosEntretenimiento;
    default:
      return {};
  }
};
